import { FC, PropsWithChildren, useCallback, useEffect } from "react";

import { usePlayerStore } from "../store/usePlayerStore";

const getUiSizeInPx = async (element: Element): Promise<number> =>
  new Promise<number>(resolve => {
    const observer = new IntersectionObserver(nodes => {
      observer.disconnect();
      resolve(nodes[0].boundingClientRect.width);
    });
    observer.observe(element);
  });

interface Props extends PropsWithChildren {
  playerElement: HTMLElement;
}

export const UiSizeResolver: FC<Props> = ({ children, playerElement }) => {
  const { useStoreState } = usePlayerStore();
  const setUiSize = useStoreState.setUiSize();

  const resolveUiSize = useCallback(async () => {
    setUiSize(await getUiSizeInPx(playerElement));
  }, [playerElement, setUiSize]);

  useEffect(() => {
    resolveUiSize();
    window.addEventListener("resize", resolveUiSize, false);

    return () => {
      window.removeEventListener("resize", resolveUiSize, false);
    };
  }, [resolveUiSize]);

  return children;
};
